const ROLE_KEY = 'movieBookingRole';

export const getMovieBookingRole = () => {
  return localStorage.getItem(ROLE_KEY);
};

export const setMovieBookingRole = (role) => {
  localStorage.setItem(ROLE_KEY, role);
};

export const clearMovieBookingRole = () => {
  localStorage.removeItem(ROLE_KEY);
};

export const isAdminRole = (user) => {
  return !!user?.roles?.includes('ROLE_ADMIN');
};
